module.exports = __webpack_public_path__ + "static/media/3.af6a06b2.png";